import React from "react";
import { Box, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { CheckCircleOutlineRounded, Close } from "@material-ui/icons";

type QrStage = "checking" | "generating" | "completed" | undefined;

interface QrOverlayProps {
  qrStage: QrStage;
  fileName?: string;
  checkingText?: string;
  generatingText?: string;
  successText?: string;
  onClose?: () => void;
}

const QrOverlay: React.FC<QrOverlayProps> = ({
  qrStage,
  fileName,
  checkingText,
  generatingText = "Generating QR PDF...",
  successText,
  onClose,
}) => {
  if (!qrStage) return null; // hide overlay if no stage

  // const isError = !!successText && successText.toLowerCase().includes("no ");

  const ERROR_PHRASES = ["failed", "no ", "error", "not found", "unavailable"];
const isErrorMessage = (text?: string): boolean => {
  if (!text) return false;
  const lower = text.toLowerCase();
  return ERROR_PHRASES.some((phrase) => lower.includes(phrase));
};

// Then inside the component, replace with:
const isError = !!successText && isErrorMessage(successText);

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      zIndex={1300}
      style={{ backgroundColor: "rgba(101, 101, 101, 0.2)" }}
    >
      <div
        style={{
          maxWidth: "50%",
          padding: "20px",
          backgroundColor: isError ? "#fff3f3" : "#e5ffe0ff",
          border: isError ? "1px solid #d32f2f" : "1px solid green",
          borderRadius: "20px",
          display: "flex",
          gap: "16px",
          alignItems: "center",
          justifyContent: "center",
          position: qrStage === "completed" ? "fixed" : "static",
          top: qrStage === "completed" ? "20%" : "auto",
        }}
      >
        {qrStage === "completed" && onClose && (
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 8,
              right: 12,
              background: "transparent",
              border: "none",
              fontSize: 20,
              color: isError ? "#d32f2f" : "green",
              cursor: "pointer",
              zIndex: 2,
            }}
            aria-label="Close"
          >
            <Close style={{ color: isError ? "#d32f2f" : "green" }} />
          </button>
        )}
        {qrStage === "completed" ? (
          !isError ? <CheckCircleOutlineRounded style={{ color: "green" }} /> : ""
        ) : (
          <CircularProgress size={24} thickness={4} style={{ color: "green" }} />
        )}

        <Typography style={{ fontSize: 14, fontWeight: 400, color: "#333" }}>
          {(qrStage === "checking" ) && checkingText}
          {(qrStage === "generating" ) && generatingText}

          {qrStage === "completed" && (
            <div style={{ fontSize: "12px", color: "#666" }}>
              <Typography style={{ fontWeight: 600 }}>{isError ? "Error" : "Success"}</Typography>
              <Typography>
                {successText ??
                  `Successfully downloaded ${fileName ?? "the files"}`}
              </Typography>
            </div>
          )}
        </Typography>
      </div>
    </Box>
  );
};

export default QrOverlay;
